import Button from '@aurora/shared-client/components/common/Button/Button';
import { ButtonVariant } from '@aurora/shared-client/components/common/Button/enums';
import { dropdownPopperConfig } from '@aurora/shared-client/helpers/ui/PopperJsHelper';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import React from 'react';
import { Dropdown, useClassNameMapper } from 'react-bootstrap';
import useTranslation from '../../useTranslation';
import type { MessageListTabItem } from '../MessageListTabs/MessageListTabs';

interface SortFilters {
  /**
   * Key for tab item
   */
  key: MessageListTabItem;
  /**
   * value of tab item
   */
  value: string;
}

interface Props {
  /**
   * Class name(s) to apply to the component element.
   */
  className?: string;
  /**
   * the selected sort filter value
   */
  selectedSortFilterValue: string;
  /**
   * Array of sort filters
   */
  sortFilters: SortFilters[];
  /**
   * Callback function when a sort is selected.
   *
   * @param item - the selected sort
   */
  onSortFilterChange: (item: MessageListTabItem) => void;
}

/**
 * Messages sorts options.
 *
 * @author Be.Abhijith
 */
const MessagesSortOptions = ({
  className,
  selectedSortFilterValue,
  sortFilters,
  onSortFilterChange
}: Props): React.ReactElement => {
  const cx = useClassNameMapper();
  const { formatMessage, loading: textLoading } = useTranslation(
    EndUserComponent.MESSAGE_SORT_OPTIONS
  );

  if (textLoading) {
    return null;
  }

  return (
    <Dropdown className={cx('lia-g-py-5', className)} data-testid="MessagesSortOptions.Dropdown">
      <Dropdown.Toggle
        as={Button}
        variant={ButtonVariant.LINK}
        size="sm"
        className={cx('lia-g-dropdown-toggle')}
      >
        {selectedSortFilterValue}
      </Dropdown.Toggle>
      <Dropdown.Menu align="right" popperConfig={dropdownPopperConfig}>
        <Dropdown.Header>{formatMessage('sortFilter')}</Dropdown.Header>
        {sortFilters.map(sortFilter => {
          return (
            <Dropdown.Item
              key={sortFilter.key}
              active={sortFilter.key === selectedSortFilterValue}
              onSelect={(): void => onSortFilterChange(sortFilter.key)}
              aria-label={sortFilter.key}
            >
              {sortFilter.value}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MessagesSortOptions;
